<template>
  <v-container fluid>
    <!-- <v-overlay :value="loading" v-if="loading">
      <img src="../assets/White-icon.svg" width="250" height="180" class="mt-5 imageRotateHorizontal"><br>
      <p class="headline" style="margin-left:3em;">Loading...</p>
    </v-overlay> -->
    <v-row class="upperDiv mt-6 mt-lg-7 mt-md-7 mt-xl-7 mt-xs-4 mt-sm-7">
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="7"
        xl="7"
        class="d-md-none d-lg-none d-xl-none d-xs-flex d-sm-flex text-xs-center"
      >
        <transition name="fade">
          <img
            :src="require('../assets/main.jpg')"
            width="360"
            height="240"
            class="mt-12"
            v-if="show"
            style="border-radius: 25px"
          />
        </transition>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="12" lg="5" xl="5">
        <p
          class="maintxt mt-2 mt-xs-2 mt-sm-2 mt-md-8 mt-lg-8 mt-xl-8 pt-2 pt-xs-2 pt-sm-2 pt-md-8 pt-lg-8 pt-xl-8 pl-md-7 pl-lg-7 pl-xl-7 deep-purple--text"
        >
          We are manufacturing
        </p>
        <transition name="fade">
          <p
            class="maintxt2 pl-md-7 pl-lg-7 pl-xl-7 deep-purple--text"
            v-if="show"
          >
            Industrial Valves
          </p>
        </transition>
        <p class="mt-3 pt-2 pl-md-9 pl-lg-9 pl-xl-9 blue--black">
          We Focuses On The Design, Develop, Manufacture. All Casting & Forging
          are checked by means of chemical analysis and mechanical tests to
          guarantee that all raw materials conform to specifications such as
          those of the ASTM.
        </p>
        <v-btn
          rounded
          class="btns mt-5 ml-md-7 ml-lg-7 ml-xl-7"
          outlined
          dark
          @click="scrollTo"
          >Product <v-icon right>mdi-arrow-right</v-icon></v-btn
        >
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="7"
        xl="7"
        class="d-none d-lg-flex d-xl-flex text-xs-center"
      >
        <transition name="fade">
          <img
            :src="require('../assets/main.jpg')"
            width="900"
            height="560"
            v-if="show"
            style="border-radius: 0 0 0 50%"
          />
        </transition>
      </v-col>
    </v-row>
    <v-row class="aboutusDiv mt-10" id="about">
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="6"
        xl="6"
        class="d-none d-lg-flex d-xl-flex text-xs-center"
      >
        <img
          src="../assets/about.jpg"
          width="600"
          height="380"
          class="mt-5 ml-10 ml-lg-10 ml-xl-10 ml-md-10"
          style="border-radius: 0 40% 0 0"
        />
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="6"
        xl="6"
        class="d-lg-none d-xl-none d-xs-flex d-sm-flex d-md-none text-xs-center"
      >
        <img
          src="../assets/about.jpg"
          class="mt-10 mt-xs-10 mt-sm-10"
          width="360"
          height="240"
        />
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="6"
        xl="6"
        class="mt-5 pr-md-4 pr-lg-4 pr-xl-4"
        style="position: relative"
      >
        <!-- <img src="../assets/triangle.png" width="35" height="35" class="shapesbounce bounce-1"/>
        <img src="../assets/bubble.png" width="35" height="35" class="shapes1bounce bounce-1"/> -->
        <div
          class="text-lg-right text-xl-right text-md-right px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 headline font-weight-light deep-purple--text"
        >
          About us
        </div>
        <div
          class="text-lg-right text-xl-right text-md-right px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 display-1 mt-2 font-weight-regular deep-purple--text"
        >
          Know Interesting Things
        </div>
        <v-row>
          <v-col
            cols="4"
            md="2"
            lg="2"
            xl="2"
            sm="4"
            xs="4"
            offset-md="9"
            offset-lg="9"
            offset-xl="9"
            class="mt-3"
          >
            <div class="bottomBorder"></div>
          </v-col>
        </v-row>
        <div
          class="text-lg-right text-xl-right text-md-right px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 title font-weight-light"
        >
          VYAGO has
          become a synonym for reliable and dependable Valves required for
          high/low pressure, high/low temperature and for highly corrosive
          fluids.
        </div>
        <!-- <div class="text-lg-right text-xl-right text-md-right px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 mt-8">
          <v-btn rounded class="btns" dark  @click="goTo('/aboutus')">Read More
            <v-icon right>mdi-arrow-right</v-icon> 
          </v-btn>
        </div> -->
      </v-col>
    </v-row>
    <v-row class="servicesDiv" id="products">
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="6"
        class="pl-md-4 pl-lg-4 pl-xl-4 servicetext"
        style="position: relative"
      >
        <!-- <img src="../assets/triangle.png" width="35" height="35" class="shapesbounce bounce-1"/>
        <img src="../assets/bubble.png" width="35" height="35" class="shapes1bounce bounce-1"/> -->
        <div
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 headline font-weight-light deep-purple--text"
        >
          Our Products
        </div>
        <div
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 display-1 mt-2 font-weight-regular deep-purple--text"
        >
          Products We Provide
        </div>
        <v-row>
          <v-col
            cols="4"
            md="2"
            lg="2"
            xl="2"
            sm="4"
            xs="4"
            class="mt-3 ml-md-10 ml-lg-10 ml-xl-10"
          >
            <div class="bottomBorder"></div>
          </v-col>
        </v-row>
        <div
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 title font-weight-light"
        >
          <v-row>
            <v-col cols="10" md="6" lg="6" xl="6" sm="10" xs="10">
              <ul>
                <li>Ball Valve</li>
                <li>Butterfly Valve</li>
                <li>Plug Valve</li>
                <li>Gate Valve</li>
                <li>Globe Valve</li>
                <li>Swing Check Valve</li>
              </ul>
            </v-col>
            <v-col cols="10" md="6" lg="6" xl="6" sm="10" xs="10">
              <ul>
                <li>Dual Plate Check Valve</li>
                <li>Single Plate Check Valve</li>
                <li>Diaphragm Valve</li>
                <li>Needle Valve</li>
                <li>Srainer 'Y' Type</li>
              </ul>
            </v-col>
          </v-row>
        </div>
        <div
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 mt-8"
        >
          <v-btn rounded class="btns" dark @click="downloadCat"
            >Get Catalogue
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="mt-12">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <v-card
              class="mx-auto text-center"
              max-width="400"
              style="background-color: transparent"
              elevation="0"
            >
              <img
                class="mt-8 mb-3"
                src="../assets/product1.jpeg"
                width="350"
              />
            </v-card>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <v-card
              class="mx-auto text-center"
              max-width="400"
              style="background-color: transparent"
              elevation="0"
            >
              <img
                class="mt-8 mb-3"
                src="../assets/product2.jpeg"
                width="350"
              />
            </v-card>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            xl="6"
            offset-md="3"
            offset-lg="3"
            offset-xl="3"
          >
            <v-card
              class="mx-auto text-center"
              max-width="400"
              height="350"
              style="background-color: transparent"
              elevation="0"
            >
              <img
                class="mt-8 mb-3"
                src="../assets/product3.jpeg"
                width="350"
              />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="tesimonials" id="client">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <div
          class="text-center px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 display-1 mt-2 font-weight-regular text--white"
        >
          Our Clients
        </div>
        <v-row
          class="ml-lg-12 ml-xl-12 pl-lg-3 pl-xl-3"
          align="center"
          justify="center"
        >
          <v-col
            cols="4"
            md="2"
            lg="2"
            xl="2"
            sm="4"
            xs="4"
            class="mt-3 ml-md-10 ml-lg-10 ml-xl-10"
          >
            <div class="bottomBorder"></div>
          </v-col>
        </v-row>
        <v-carousel
          cycle
          height="275"
          hide-delimiters
          show-arrows-on-hover
          class="mt-12"
        >
          <v-carousel-item v-for="i in 8" :key="i">
            <v-sheet
              color="transparent"
              height="100%"
              align="center"
              justify="center"
            >
              <v-row align="center" justify="center">
                <div>
                  <img
                    :src="require('../assets/' + i + '.png')"
                    alt="John"
                    width="300"
                  />
                </div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
    <v-row class="technologiesDiv">
      <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="text-center">
        <v-card
          class="mx-auto text-center elevation-0"
          v-waypoint="{
            active: true,
            callback: onWaypoint,
            options: intersectionOptions,
          }"
        >
          <v-icon class="mt-8 mb-3 display-4" color="deep-purple">
            mdi-account-multiple-outline
          </v-icon>

          <v-card-subtitle
            class="pb-0 display-1 font-weight-regular text--darken-4 deep-purple--text"
          >
            <animated-number
              :value="clientCount"
              :formatValue="formatTodigit"
              :duration="1000"
            />+</v-card-subtitle
          >

          <v-card-text
            class="mt-2 pb-2 title text--darken-4 deep-purple--text font-weight-light"
          >
            <div>CLIENTS</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="text-center">
        <v-card
          class="mx-auto text-center elevation-0"
          v-waypoint="{
            active: true,
            callback: onWaypoint2,
            options: intersectionOptions,
          }"
        >
          <v-icon class="mt-8 mb-3 display-4" color="deep-purple">
            mdi-package
          </v-icon>

          <v-card-subtitle
            class="pb-0 display-1 font-weight-regular text--darken-4 deep-purple--text"
          >
            <span
              class="numscroller"
              data-min="1"
              data-max="4"
              data-delay="1"
              data-increment="1"
              ><animated-number
                :value="projectCount"
                :formatValue="formatTodigit"
                :duration="1000" /></span
            >+
          </v-card-subtitle>

          <v-card-text
            class="mt-2 pb-2 title text--darken-4 deep-purple--text font-weight-light"
          >
            <div>PRODUCTS</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="text-center">
        <v-card
          class="mx-auto text-center elevation-0"
          v-waypoint="{
            active: true,
            callback: onWaypoint3,
            options: intersectionOptions,
          }"
        >
          <v-icon class="mt-8 mb-3 display-4" color="deep-purple">
            mdi-truck-delivery
          </v-icon>

          <v-card-subtitle
            class="pb-0 display-1 font-weight-regular text--darken-4 deep-purple--text"
            ><animated-number
              :value="techCount"
              :formatValue="formatTodigit"
              :duration="1000"
            />+</v-card-subtitle
          >

          <v-card-text
            class="mt-2 pb-2 title text--darken-4 deep-purple--text font-weight-light"
          >
            <div>ORDERS DELIVERED</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="footerDiv" id="contact">
      <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
        <img
          src="../assets/logo.jpeg"
          width="320"
          height="80"
          class="mt-12 ml-md-8"
        /><br />
        <div
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 title font-weight-light"
        >
          "We help organizations streamline their efforts by providing
          customer-specific solutions."
        </div>
        <div
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 title font-weight-light mt-5"
        >
          <v-btn icon color="deep-purple" @click="openlinks('https://www.facebook.com/vyagoengineers?mibextid=LQQJ4d')">
            <v-icon>mdi-facebook</v-icon>
          </v-btn>
          <v-btn icon color="deep-purple" class="ml-3">
            <v-icon>mdi-linkedin</v-icon>
          </v-btn>
          <v-btn icon color="deep-purple" class="ml-3">
            <v-icon>mdi-instagram</v-icon>
          </v-btn>
          <v-btn icon color="deep-purple" class="ml-3">
            <v-icon>mdi-twitter</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="footerblock">
        <div
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 headline font-weight-light"
        >
          Quick Links
        </div>
        <v-row>
          <v-col
            cols="4"
            md="2"
            lg="2"
            xl="2"
            sm="4"
            xs="4"
            class="mt-3 ml-md-10 ml-lg-10 ml-xl-10"
          >
            <div class="bottomBorder"></div>
          </v-col>
        </v-row>
        <p
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 mt-5 ml-1"
        >
          <a
            style="text-decoration: none; color: #4527a0"
            @click="goTo('about')"
            >About</a
          >
        </p>
        <p
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 ml-1"
        >
          <a
            style="text-decoration: none; color: #4527a0"
            @click="goTo('products')"
            >Products</a
          >
        </p>
        <p
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 ml-1"
        >
          <a
            style="text-decoration: none; color: #4527a0"
            @click="goTo('client')"
            >Clients</a
          >
        </p>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="footerblock">
        <div
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 headline font-weight-light"
        >
          Contact Us
        </div>
        <v-row>
          <v-col
            cols="4"
            md="2"
            lg="2"
            xl="2"
            sm="4"
            xs="4"
            class="mt-3 ml-md-10 ml-lg-10 ml-xl-10"
          >
            <div class="bottomBorder"></div>
          </v-col>
        </v-row>
        <v-row
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 mt-5 ml-1"
        >
          <v-icon color="deep-purple">mdi-phone</v-icon>
          <span class="ml-5">+91-9429297464 / 8160685425</span>
        </v-row>
        <v-row
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 mt-5 ml-1"
        >
          <v-icon color="deep-purple">mdi-email</v-icon>
          <span class="ml-5"
            ><a
              href="mailto:info@vyagoengineers.com"
              style="text-decoration: none; color: #4527a0"
              >info@vyagoengineers.com</a
            ></span
          >
          <span class="ml-11"
            ><a
              href="mailto:vyagoengineers@outlook.com"
              style="text-decoration: none; color: #4527a0"
              >vyagoengineers@outlook.com</a
            ></span
          >
        </v-row>
        <v-row
          class="text-lg-left text-xl-left text-md-left px-md-10 px-lg-10 px-xl-10 px-sm-5 px-xs-5 mt-5 ml-1"
        >
          <v-icon color="deep-purple">mdi-map-marker</v-icon>
          <span class="ml-5">18, Shubham Industrial Estate,</span>
          <span class="ml-12">Near Torrent Power Sub-station,</span>
          <span class="ml-12">Nikol Ring Road, Nikol,</span>
          <span class="ml-12">Ahmedabad, Gujarat, 382350</span>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AnimatedNumber from "animated-number-vue";
import PDF from "../assets/product_catalogue.pdf";

export default {
  name: "Home",

  data: () => ({
    statements: [
      "Mobile Applications",
      "Web Applications",
      "Digital Marketing",
    ],
    images: ["mobile", "main", "marketing"],
    counter: 0,
    loading: true,
    show: true,
    intersectionOptions: {
      root: null,
      rootMargin: "0px 0px 0px 0px",
      threshold: [0, 1], // [0.25, 0.75] if you want a 25% offset!
    },
    clientCount: 0,
    codeCount: 0,
    projectCount: 0,
    techCount: 0,
  }),
  components: {
    AnimatedNumber,
  },
  methods: {},
  created() {
    // setInterval(()=>{
    //   this.show = false;
    //   if(this.counter == this.statements.length-1){
    //     this.counter = 0;
    //   }
    //   else{
    //     this.counter++;
    //   }
    //   setTimeout(()=>{
    //     this.show = true;
    //   },300);
    // },5000);
    // setTimeout(()=>{
    //   this.loading = false;
    // },3500);
  },
  methods: {
    goTo(path) {
      let id = "#" + path;
      document.querySelector(id).scrollIntoView({ behavior: "smooth" });
    },
    scrollTo() {
      document
        .querySelector("#products")
        .scrollIntoView({ behavior: "smooth" });
    },
    openlinks(sociallink) {
      window.open(sociallink, "_blank");
    },
    formatTodigit(value) {
      return Number(value).toFixed(0);
    },
    onWaypoint({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.clientCount = 50;
      }
    },
    onWaypoint1({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.codeCount = 90;
      }
    },
    onWaypoint2({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.projectCount = 50;
      }
    },
    onWaypoint3({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.techCount = 250;
      }
    },
    downloadCat() {
      var anchor = document.createElement("a");
      anchor.setAttribute("href", PDF);
      anchor.setAttribute("download", "");
      document.body.appendChild(anchor);
      anchor.click();
      anchor.parentNode.removeChild(anchor);
    },
  },
};
</script>
<style>
.upperDiv {
  position: relative;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.aboutusDiv {
  background-color: white;
}
.servicesDiv {
  background: linear-gradient(
    0deg,
    rgba(65, 62, 152, 0.4) 0%,
    rgba(170, 161, 224, 0) 100%
  );
}
.servicetext {
}
.caseStudyDiv {
  background-color: white;
}
.technologiesDiv {
  background: white;
}
.gradText {
  color: linear-gradient(
    0deg,
    rgba(179, 229, 255, 1) 0%,
    rgba(255, 255, 255, 1) 90%
  ) !important;
}
.footerDiv {
  background: white;
  color: #4527a0;
}
.tesimonials {
  background: white;
  color: #4527a0;
}
.testiwidth {
}
.footerblock {
}

.shapes {
  position: absolute;
  top: 6em;
  left: 9em;
  -webkit-animation: spin 15s linear infinite;
  -moz-animation: spin 15s linear infinite;
  animation: spin 15s linear infinite;
}
.shapes1 {
  position: absolute;
  top: 9.5em;
  left: 13em;
  -webkit-animation: spin 15s linear infinite;
  -moz-animation: spin 15s linear infinite;
  animation: spin 15s linear infinite;
}
.shapes2 {
  position: absolute;
  top: 10.5em;
  left: 7em;
  -webkit-animation: spin 15s linear infinite;
  -moz-animation: spin 15s linear infinite;
  animation: spin 15s linear infinite;
}
.shapesbounce {
  position: absolute;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  transform-origin: bottom;
  animation-timing-function: linear;
}
.shapes1bounce {
  position: absolute;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  transform-origin: bottom;
}
.bounce-1 {
  animation-name: bounce-1;
  animation-timing-function: linear;
}
@keyframes bounce-1 {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0);
  }
}
.maintxt {
  margin-bottom: 0 !important;
}
.maintxt2 {
  margin-bottom: 0 !important;
}
@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@media screen and (max-width: 2500px) {
  .upperDiv {
    height: 33em;
  }
  .aboutusDiv {
    height: 25em;
  }
  .servicesDiv {
    height: 50em;
  }
  .servicetext {
    margin-top: 150px;
  }
  .caseStudyDiv {
    height: 40em;
  }
  .technologiesDiv {
    height: 20em;
  }
  .tesimonials {
    height: 30em;
  }
  .testiwidth {
    max-width: 75%;
  }
  .footerDiv {
    height: 30em;
  }
  .footerblock {
    margin-top: 90px;
  }
  .maintxt {
    font-size: 45px;
  }
  .maintxt2 {
    font-size: 45px;
  }
  .shapesbounce {
    top: 1.2em;
    left: 25em;
  }
  .shapes1bounce {
    top: 2.2em;
    left: 28em;
  }
}
@media screen and (max-width: 1600px) {
  .upperDiv {
    height: 33em;
  }
  .aboutusDiv {
    height: 25em;
  }
  .servicesDiv {
    height: 40em;
  }
  .servicetext {
    margin-top: 150px;
  }
  .caseStudyDiv {
    height: 40em;
  }
  .technologiesDiv {
    height: 20em;
  }
  .tesimonials {
    height: 30em;
  }
  .testiwidth {
    max-width: 75%;
  }
  .footerDiv {
    height: 30em;
  }
  .footerblock {
    margin-top: 90px;
  }
  .maintxt {
    font-size: 45px;
  }
  .maintxt2 {
    font-size: 45px;
  }
  .shapesbounce {
    top: 1.2em;
    left: 25em;
  }
  .shapes1bounce {
    top: 2.2em;
    left: 28em;
  }
}
@media screen and (max-width: 800px) {
  .upperDiv {
    height: 42em;
  }
  .aboutusDiv {
    height: 50em;
  }
  .servicesDiv {
    height: 100em;
  }
  .servicetext {
    margin-top: 100px;
  }
  .caseStudyDiv {
    height: 75em;
  }
  .technologiesDiv {
    height: 72em;
  }
  .tesimonials {
    height: 35em;
  }
  .testiwidth {
    max-width: 100%;
  }
  .footerDiv {
    height: 55em;
  }
  .footerblock {
    margin-top: 10px;
  }
  .maintxt {
    font-size: 40px;
  }
  .maintxt2 {
    font-size: 40px;
  }
  .shapesbounce {
    top: 1.2em;
    left: 7.5em;
  }
  .shapes1bounce {
    top: 2.2em;
    left: 10.5em;
  }
}
@media screen and (max-width: 400px) {
  .upperDiv {
    height: 42em;
  }
  .aboutusDiv {
    height: 50em;
  }
  .servicesDiv {
    height: 95em;
  }
  .servicetext {
    margin-top: 0px;
  }
  .caseStudyDiv {
    height: 75em;
  }
  .technologiesDiv {
    height: 72em;
  }
  .tesimonials {
    height: 35em;
  }
  .testiwidth {
    max-width: 100%;
  }
  .footerDiv {
    height: 55em;
  }
  .footerblock {
    margin-top: 10px;
  }
  .maintxt {
    font-size: 32px;
  }
  .maintxt2 {
    font-size: 32px;
  }
  .shapesbounce {
    top: 1.2em;
    left: 7.5em;
  }
  .shapes1bounce {
    top: 2.2em;
    left: 10.5em;
  }
}
</style>